<template>
<div>
    <div class="modal fade" id="edit-pm-modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$lang('Project manager') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="type">{{$lang('Osoba:')}}</label>
                        <select id="type" name="type" class="form-control" v-model="manager_id">
                            <option v-for="person in people" :value="person.id">{{person.full_name}}</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{
                            $lang('Zamknij')
                        }}
                    </button>
                    <button id="pm-edit-save" @click.prevent="update()" type="button" class="btn btn-primary">
                        {{ $lang('Zapisz') }}
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "project-pm",
    props: {
        people: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            saveUrl: '',
            manager_id: null
        }
    },
    methods: {
        update() {
            let self = this;
            axios.post(self.saveUrl, {manager_id: self.manager_id})
                 .then(function (response) {
                     window.location.reload();
                 })
                 .catch((error) => {
                     console.log(error);
                 });
        }
    },
    mounted() {
        let self = this;
        $('#edit-pm-modal').on('show.bs.modal', function (e) {
            self.manager_id = $(e.relatedTarget).data('manager-id');
            self.saveUrl = $(e.relatedTarget).data('url-save');

            console.log(self.saveUrl);
        })
    }
}
</script>

<style scoped>

</style>
